import React from 'react';
import { TextArea } from 'semantic-ui-react';
import { validationClasses } from '@/utils/errors';
import { camelConverter } from '../helper';

const FormTextArea = ({
  autoFocus,
  disabled,
  error,
  field,
  text,
  onChange,
}) => (
  <TextArea
    autoFocus={autoFocus}
    className={validationClasses(error, 'aridhia-form-text-area')}
    disabled={disabled}
    id={camelConverter(field.name, '_')}
    onChange={(e) => onChange(e.target.value)}
    placeholder={field.placeholder}
    rows={3}
    value={text || ''}
  />
);

export default FormTextArea;
